<template>
<div>
  <div class="voteList" v-infinite-scroll="loadMore" infinite-scroll-disabled="finite" infinite-scroll-distance="40">
    <div class="et-tabhead">
        <span class="et-back" @click="detail">
          <i class="icon-back"></i>
          详情
        </span>
      <div class="et-tabtn">
        <div class="et-tabtn" id="but-tabtn">
            <span :class="category?'btn-et-form et-form-on':'btn-et-form'" @click="form(1)">
                  <i class="icon-form"></i>投票
                </span>
            <span :class="category?'btn-et-form':'btn-et-form et-form-on'" @click="form(2)">
              <i class="icon-vote"></i>排名
            </span>
        </div>
      </div>
    </div>
    <div class="list show-box" style="margin-top: 6px">
      <div class="vote_search">
        <!--<input  type="text" placeholder="输入编号或名称" v-model="textSearck"/>
        <i class="icon-search" @click="searchCon()"></i>-->
      </div>
      <div class="vote-table" v-show="voteTable">
        <span :class="voteActives?'video voteActive':'video'"  @click="voteActive(1)">视频</span>
        <span :class="!voteActives?'image voteActive':'image'" @click="voteActive(2)">图片</span>
      </div>
      <ul class="show-list" ref="listL">
        <li style="" v-for="(item,key) in voteListL">
          <a class="VoteList-a vote-border video-border" href="javascript:void(0);">
         <!-- <router-link tag="a">-->
            <!--<span  @click="preview(item)">-->
            <router-link tag="a"
                         :to="{name:'list_preview',params: {id: id,uuid:item.uuid,ind: item.file_type,activityId: item.activity_id}}">
              <div class="pic-box pic-margin">
                <img v-if="item.file_type == 1" :src="item.thumb_path+'?p=3&o=2&w=350&h=197'" alt=""/>
                <img v-if="item.file_type == 2" :src="item.file_path+'?p=3&o=2&w=350&h=197'" alt=""/>
                <img v-if="!item.thumb_path && !item.file_path" src="" alt=""/>
                <i class="icon-time" v-if="item.time_span">{{item.time_span|formatSeconds}}</i>
                <em  v-if="!category && item.rank < '100'" class="icon-ranknum" style="top: -9px">{{item.rank}}</em>
              </div>
              <p>{{item.title}}</p>
              <div class="vode-user" >
                <i class="icon-mine"><img :src="item.face_url" alt=""/></i>{{item.nickname,14|ellipsis}}
              </div>
           <!-- </span>-->
            </router-link>
          <!--排名-->
          <div v-if="!category">
            <div class="show-pro">
              <div class="show-bar" :style="{width: item.vote_count/item.vote_sum*100+'%'}"></div>
            </div>
            <p class="show-poll">
              <span class="ranking">票数 : <i>{{item.vote_count}}</i></span>
              <span class="votesNumber">排名 : <i>{{item.rank}}</i></span>
            </p>
          </div>
          <!--投票-->
          <div v-else>
            <div  :class="item.end_time/1 >(new Date()).getTime() && (new Date()).getTime()>item.start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over'" :activity_id="item.activity_id" :data-id="item.uuid">
              <i class="icon-poll"><em>+1</em></i>投票
            </div>
            <p class="show-poll">
              <span>{{item.vote_count}}</span>票
            </p>
          </div>
          </a>
          <div class="vote_bg"></div>
        </li>
      </ul>
      <ul class="show-list" ref="listR">
        <li style="" v-for="(item,key) in voteListR">
          <a class="VoteList-a vote-border video-border" href="javascript:void(0);">
         <!-- <router-link tag="a">-->
            <!--<span  @click="preview(item)">-->
            <router-link tag="a"
                         :to="{name:'list_preview',params: {id: id,uuid:item.uuid,ind: item.file_type,activityId: item.activity_id}}">
              <div class="pic-box pic-margin">
                <img v-if="item.file_type == 1" :src="item.thumb_path+'?p=3&o=2&w=350&h=197'" alt=""/>
                <img v-if="item.file_type == 2" :src="item.file_path+'?p=3&o=2&w=350&h=197'" alt=""/>
                <img v-if="!item.thumb_path && !item.file_path" src="" alt=""/>
                <i class="icon-time" v-if="item.time_span">{{item.time_span|formatSeconds}}</i>
                <em  v-if="!category && item.rank < '100'" class="icon-ranknum" style="top: -9px">{{item.rank}}</em>
              </div>
              <p>{{item.title}}</p>
              <div class="vode-user" >
                <i class="icon-mine"><img :src="item.face_url" alt=""/></i>{{item.nickname,14|ellipsis}}
              </div>
           <!-- </span>-->
            </router-link>
          <!--排名-->
          <div v-if="!category">
            <div class="show-pro">
              <div class="show-bar" :style="{width: item.vote_count/item.vote_sum*100+'%'}"></div>
            </div>
            <p class="show-poll">
              <span class="ranking">票数 : <i>{{item.vote_count}}</i></span>
              <span class="votesNumber">排名 : <i>{{item.rank}}</i></span>
            </p>
          </div>
          <!--投票-->
          <div v-else>
            <div  :class="item.end_time/1 >(new Date()).getTime() && (new Date()).getTime()>item.start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over'" :activity_id="item.activity_id" :data-id="item.uuid">
              <i class="icon-poll"><em>+1</em></i>投票
            </div>
            <p class="show-poll">
              <span>{{item.vote_count}}</span>票
            </p>
          </div>
          </a>
          <div class="vote_bg"></div>
        </li>
      </ul>
      <!-- <div class="voteh5" style="text-align: center;line-height: 100px;">加载中....</div> -->
      <!-- <div class="show-list-div" v-if="voteList.length <= 0">共查找到0个文件</div> -->
    </div>
    <!-- load -->
    <div class="content index-content" v-if="busy" style="padding-top: 0">
      <div class="id-content-inner">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="noMore" class="footer" style="text-align: center;padding: 5px 0 10px 0;color: #ccc;">没有更多了</div>
    <VoteAlert></VoteAlert>
  </div>
</div>
</template>

<script>
    import voteAlert from '../template/voteAlert.vue';
    export default {
      data (){
        return {
          category: true,
          id: '',
          NumberName: 10,
          page: 0,
          type: 1,
          orderObj: {
            order: 'id',
            sort: 'SORT_DESC'
          },
          getVoteList:{},
          voteList: [],
          voteListL: [],
          voteListR: [],
          route: '',
          total: 0,
          voteActives: true,
          textSearck: '',
          busy: true,
          noMore:false,
          voteTable: false,
          getState: false,
          leave: false,
          LH: 0,
          RH: 0,
          LW: 0,
        }
      },
      components:{
        VoteAlert: voteAlert
      },
      computed: {
        finite: function(){
          return this.busy || this.noMore || this.leave;
        }
      },
      methods: {
        //操作按钮事件
        fn(){
          // console.log(0)
          var num = [],
              that = this;
          var getVoteList = {
            type: 1,
            activity_id: that.id,
            page: 1,
            pagesize: that.NumberName,
            order: 'id',
            sort: 'SORT_DESC'
          };
          var getVoteList2 = {
            type: 2,
            activity_id: that.id,
            page: 1,
            pagesize: that.NumberName,
            order: 'id',
            sort: 'SORT_DESC'
          };
          var getList = function(params){
            return new Promise(function(resolve,reject){
              that.$http.get(API.GetGetVoteList, {params: params})
                .then(function (res) {
                    resolve(res);
                });
            })
          }
          var getLists = async function(){
            var video = await getList(getVoteList);
            var image = await getList(getVoteList2);
            // console.log(video,image)
            return {video,image}
          }
          getLists().then(function(res){
            let {video,image} = res
            if(video.code ==0 && image.code == 0){
                if(video.total <= 0 && image.total <=0){
                   that.$router.push({name: 'Detail', params: {id: that.id}});
                   return;
                }
                if(video.total >0 && image.total>0){
                  that.voteTable = true;
                }
                if(video.total > 0 && image.total <=0){
                    that.type = 1;
                    that.voteTable = false;

                }
                if(video.total <= 0 && image.total > 0){
                    that.type = 2;
                    that.voteTable = false;
                }
                // that.getState = true;
                that.busy = false;
                that.loadMore();

            }else{
              console.log(res);
            }
          }).catch(function(e){
            console.log(e);
          });

          // that.$http.get(API.GetGetVoteList, {params: getVoteList})
          //   .then(function (res) {
          //   if(res.code == 0 && res.total > 0){
          //     console.log('1')
          //     that.$http.get(API.GetGetVoteList, {params: getVoteList2})
          //       .then(function (res) {
          //         console.log('2')
          //         if(res.code == 0 && res.total > 0){
          //           // $('.vote-table').show()
          //           that.voteTable = true;
          //         }else{
          //           // $('.vote-table').hide()
          //           that.voteTable = false;
          //           that.type = 1;
          //         }
          //         that.getState = true;
          //         that.loadMore();
          //     })
          //   }else{
          //     that.$http.get(API.GetGetVoteList, {params: {...that.getVoteList,type:2}})
          //       .then(function (res) {
          //       if(res.code == 0 && res.total > 0){

          //         that.type = 2;
          //       }else{
          //           that.$router.push({name: 'Detail', params: {id: that.id}})
          //       }
          //       // $('.vote-table').hide();
          //       that.voteTable = false;
          //       that.voteActives = false;
          //       that.getState = true;
          //       that.loadMore();

          //     })
          //   }
          // });
        },
        searchCon(){
          // if(this.textSearck != ''){
          //   if(this.voteActives) {
          //     this.getVoteList = {
          //       activity_id: this.id,
          //       page: 1,
          //       type: val,
          //       pagesize: this.NumberName,
          //       order: 'id',
          //       sort: 'SORT_DESC'
          //     }
          //   }else{
          //     this.getVoteList = {
          //       activity_id: this.id,
          //       page: 2,
          //       type: val,
          //       pagesize: this.NumberName,
          //       order: 'id',
          //       sort: 'SORT_DESC'
          //     }
          //   }
          // }
        },
        preview(item){
        /*  console.log(item)
          var item = item
          console.log()*/
        },
        detail(){
          this.$router.push({name: 'Detail', params: {id: this.id}})
        },
        form(val){
          if(this.busy) return;//数据加载中...
          if(val == 1){ //判断是投票还是排名
            this.category = true;
             this.orderObj = {
              order: 'id',
              sort: 'SORT_DESC'
            }
          }else{
            this.category = false;
            this.orderObj = {
              order: 'vote_count',
              sort: 'SORT_DESC'
            }
          }
          this.page = 0;
          this.voteList = [];
          this.voteListL = [];
          this.voteListR = [];
          this.noMore = false;

          this.loadMore();
          //this.$router.push({name: 'Notice', query: {route: this.route, id: this.id}})
        },
        voteActive(val){
          if(this.busy) return;//数据加载中...
          if(val == 1){ //判读是点击视频还是图片 （视频）
            this.voteActives = true;
            this.type = 1;
          }else{  //判读是点击视频还是图片（图片）
            this.voteActives = false;
            this.type = 2
          }

          this.page = 0;
          this.voteList = [];
          this.voteListL = [];
          this.voteListR = [];
          this.noMore = false;

          this.loadMore();
          // $('.footer').hide();
        },
        fetchData() {
          var that = this;
          that.getVoteList = {
            ...that.orderObj,
            activity_id: that.id,
            page: that.page,
            type: that.type,
            pagesize: that.NumberName,
          }
          that.$http.get(API.GetGetVoteList, {params: that.getVoteList})
          .then(function (res) {
            // console.log(4)
            if(res.code == 0){
              var _data = res.data;
              that.total = res.total;

              that.loadImg(res);
            }
          })
        },
        loadImg(res){
          var that = this;
          var data = res.data;
          var total = res.total;
          var idx = 0;
          var NH,NW,CH,OH = 100;
          var img = new Image();
          function loadNext(idx){
            if(idx >= data.length) {
              that.busy = false;
              if(that.voteList.length >= total){
                that.noMore = true;
              }
              return;
            }


            if(that.type ==1){
              img.src =  data[idx].thumb_path +'?p=3&o=2&w=350&h=197';
            }else{
              img.src =  data[idx].file_path +'?p=3&o=2&w=350&h=197';
            }
            img.onload = img.onerror = () => {
              NW = img.naturalWidth;
              NH = img.naturalHeight;
              CH = NH/NW*that.LW || OH;
              if(that.getMinUl()){
                that.voteListL.push(data[idx]);
                that.LH += CH;
              }else{
                that.voteListR.push(data[idx]);
                that.RH += CH;
              }
              that.voteList.push(data[idx]);
              idx++;
              loadNext(idx);
            }
          }
          loadNext(idx);
        },
        loadMore () {
          // console.log('3')
          // if(!this.getState) return;
          if(this.busy == false){
            // setTimeout(() => {
              this.busy = true;
              this.page ++;

              this.fetchData();
            // }, 500)
          }
        },
        getMinUl() { //每次获取最短的ul,将图片放到其后

          // var L = this.$refs.listL;
          // var R = this.$refs.listR;
          // var LH = L.offsetHeight;
          // var RH = R.offsetHeight;
          // return LH <= RH ? true : false;
          return this.LH <= this.RH ? true : false;

        },
      },

      created: function () {
        this.id = this.$route.params.id;

        var that = this;
        that.fn();


        //分享微信
        $.getJSON(API.GetActivitieById + '?jsoncallback=?&id=' + that.id, function (res) {
          that.detailsTxte = res.data;
          if (res.code == 0) {
            //分享微信
            var title = '',
              desc = '';
            if(that.detailsTxte.share_config){
              var activity = that.detailsTxte.share_config.activity;
              if(activity != 'undefined' && activity &&　activity.share_title){
                title = activity.share_title
              }else{
                title = that.detailsTxte.title;
              }
              if(activity != 'undefined' && activity && activity.share_contents){
                desc = activity.share_contents
              }else{
                desc  = that.detailsTxte.description
              }
            }else{
              title =  that.detailsTxte.title;
              desc  = that.detailsTxte.description
            }
            document.title = title;
            let metas = $('head').children('meta');
            metas[1].content = desc;
            var dataName = {
              title: '我参加' +title + '活动，快帮我投票',  //分享标题
              desc: desc,//metas[1].content,//分享简介(内容)
              imgAddress: that.route,//分享图片地址
              Retain: '',//保留
              url: window.location.href//点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
            };
            that.weixinShare(dataName)
          }
        });
      },
      mounted: function () {
        //操作DOM
        var that = this;
        this.LW = this.$refs.listL.offsetWidth;
      },
      activated: function(){
        this.leave = false;
      },
      deactivated: function(){
        this.leave = true;
      }


    }
</script>

<style scoped>
.voteList .show-box .show-list{
    width: 50%;
    float: left;
    padding-right:  5px;
  }
  .show-box .show-list li {
  float: left;
  width: 100%;

}
.show-box .show-list .pic-box img {
    visibility: visible;
    min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/list/voteList.vue